import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ROUTES } from '@/utils/routes';
import { CourseProgressSelection } from '@/data/hook/student-dashboard/useStudentDashboardCourseProgresses';

export default function usePathParamCourseProgressSelection(): CourseProgressSelection {
  const { slugCourseName } = useParams();
  const navigate = useNavigate();

  return useMemo(
    () => ({
      slug: slugCourseName,
      fallbackToFirst: false,
      select: ({ coursePath, klassId }) =>
        navigate(ROUTES.COURSES.INFO(coursePath.slug, klassId), {
          replace: true,
        }),
    }),
    [slugCourseName, navigate],
  );
}
